import {Circles} from "react-loader-spinner";
import React, {useEffect, useState} from "react";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import {useQuery} from "util/useQuery";

interface KmpBridge {
	callNative: (methodName: string, params: string, callback: (data: string) => void) => void,
}

export const MobileCallbackPage = () => {
	let query = useQuery();
	const [error, setError] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (!query.has("success")) {
			setError("invalid url")
			return
		}

		// check if window has kmpJsBridge attached
		const kmpJsBridge: KmpBridge = (window as any).kmpJsBridge;
		if (!kmpJsBridge) {
		  setError("failed to connect to app")
		  return
		}

		kmpJsBridge.callNative("CheckoutPaymentSuccess", JSON.stringify({
			success: query.get('success'),
			token: query.get('token') ?? "",
			flow: query.get('flow') ?? "",
			selectedId: query.get('selectedId') ?? "",
			productType: query.get('productType') ?? "",
		}), (data: string) => {
			console.log("Callback from Native: " + data);
		});

	}, [])


	if (error) {
		return (
			<div
				style={{
					fontSize: 32,
					textAlign: 'center',
					display: "flex",
					flexDirection: "column",
					gap: 20,
					alignItems: "center",
					justifyContent: "center",
					width: "100%",
					height: "90%",
				}}
			>
				<FmdBadIcon style={{fontSize: 80}} fontSize={'inherit'} />
				<div style={{maxWidth: '70vw', textAlign: 'center'}}>{error}</div>
			</div>
		)
	}

	return (
		<div
			style={{
				fontSize: 42,
				textAlign: 'center',
				display: "flex",
				flexDirection: "column",
				gap: 20,
				alignItems: "center",
				justifyContent: "center",
				width: "100%",
				height: "90%",
			}}
		>
			<Circles
				height="60"
				width="60"
				color= "#2767ff" //"#4fa94d"
				ariaLabel="circles-loading"
				wrapperStyle={{}}
				wrapperClass=""
				visible={true}
			/>
			Finalising checkout...
		</div>
	)

}
